import { IChannel } from '@/entities/channel';

type UseChannelsPageProps = {
  channels?: IChannel[];
};

export function useChannelsPage({ channels }: UseChannelsPageProps): {
  foundChannelById: (searchChannelId?: string) => IChannel | undefined;
} {
  const foundChannelById = (searchChannelId?: string) =>
    channels?.find((channel) => channel.id === searchChannelId);

  return { foundChannelById };
}
